// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.content-ex {\n\t-webkit-box-sizing: border-box;\n\t        box-sizing: border-box;\n\tpadding: 1rem;\n\tbackground: #fff;\n}\n", ""]);
